'use strict';

function normalizeText(value) { return String(value == null ? '' : value).replace(/\r\n?/g, '\n'); }
function mentionTrigger(text, position, mentions = []) {
    const match = text.slice(0, position).match(/(?:^|[\s(])@([^@\n]{0,80})$/);
    if (!match) return null;
    const start = position - match[1].length - 1;
    // A selected person's @ is no longer a search trigger, even after more text.
    if (mentions.some(m => start >= m.start && start < m.start + m.length
        || position > m.start && position <= m.start + m.length)) return null;
    return {start, end: position, query: match[1]};
}
function validateMentions(text, value) {
    if (!Array.isArray(value) || value.length > 100) throw new Error('Некорректные упоминания.');
    let end = 0;
    return value.slice().sort((a, b) => a.start - b.start).map(item => {
        const {start, length} = item;
        const userId = Number(item.user_id);
        if (!Number.isSafeInteger(userId) || userId < 1 || !Number.isInteger(start) || !Number.isInteger(length)
            || start < end || length < 2 || start + length > text.length || text[start] !== '@'
            || /[\r\n]/.test(text.slice(start, start + length))) throw new Error('Некорректный диапазон упоминания.');
        end = start + length;
        return {user_id: userId, start, length};
    });
}

// Textarea offsets and persisted ranges both use UTF-16 code units.
function moveMentions(before, after, mentions) {
    let start = 0;
    while (start < before.length && start < after.length && before[start] === after[start]) start++;
    let oldEnd = before.length, newEnd = after.length;
    while (oldEnd > start && newEnd > start && before[oldEnd - 1] === after[newEnd - 1]) { oldEnd--; newEnd--; }
    const delta = newEnd - oldEnd;
    return (mentions || []).reduce((items, item) => {
        const end = item.start + item.length;
        if (end <= start) items.push({...item});
        else if (item.start >= oldEnd) items.push({...item, start: item.start + delta});
        return items;
    }, []);
}

function trimContent(text, mentions) {
    const leading = text.length - text.trimStart().length;
    const trimmed = text.trim();
    return {text: trimmed, mentions: (mentions || []).filter(m => m.start >= leading && m.start + m.length <= leading + trimmed.length)
        .map(m => ({...m, start: m.start - leading}))};
}

// JSONB may reorder object keys; anchors must not depend on serialization order.
function messageKey(ref, sourceOnly = false) {
    if (!ref) return '';
    const values = [ref.context_type, Number(ref.context_id), ref.source_type, Number(ref.source_id)];
    if (!sourceOnly) values.push(ref.field_key || 'body');
    return encodeURIComponent(JSON.stringify(values));
}

function textParts(text, mentions = [], quote) {
    const highlighted = quote && Number.isInteger(quote.start) && Number.isInteger(quote.length) && quote.length > 0
        && quote.start >= 0 && text.slice(quote.start, quote.start + quote.length) === quote.quote;
    const points = new Set([0, text.length]);
    const valid = mentions.filter(m => m.start >= 0 && m.start + m.length <= text.length);
    valid.forEach(m => { points.add(m.start); points.add(m.start + m.length); });
    if (highlighted) { points.add(quote.start); points.add(quote.start + quote.length); }
    const sorted = Array.from(points).sort((a, b) => a - b);
    return sorted.slice(0, -1).map((start, index) => {
        const end = sorted[index + 1], person = valid.find(m => start >= m.start && end <= m.start + m.length);
        return {text: text.slice(start, end), user_id: person && person.user_id,
            name: person && text.slice(person.start + 1, person.start + person.length),
            highlighted: Boolean(highlighted && start >= quote.start && end <= quote.start + quote.length)};
    });
}

module.exports = {normalizeText, mentionTrigger, validateMentions, moveMentions, trimContent, messageKey, textParts};
